"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Link_1 = require("office-ui-fabric-react/lib/Link");
var owa_help_1 = require("owa-help");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var HELP_WINDOW_NAME = 'o365Help';
var HELP_WINDOW_OPTIONS = 'width=400,height=500,menubar=no,status=no,scrollbars=no,titlebar=no,toolbar=no,resizable=yes';
var HelpLink = /** @class */ (function (_super) {
    tslib_1.__extends(HelpLink, _super);
    function HelpLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onHelpLink = function (ev) {
            ev.preventDefault();
            window.open(owa_help_1.getHelpUrl(_this.props.helpId), HELP_WINDOW_NAME, HELP_WINDOW_OPTIONS);
        };
        return _this;
    }
    HelpLink.prototype.render = function () {
        return (React.createElement(Link_1.Link, { href: owa_help_1.getHelpUrl(this.props.helpId), target: HELP_WINDOW_NAME, onClick: this.onHelpLink }, owa_options_strings_1.default.options_mail_linkPreviewHelpLink));
    };
    HelpLink = tslib_1.__decorate([
        mobx_react_1.observer
    ], HelpLink);
    return HelpLink;
}(React.Component));
exports.default = HelpLink;
//# sourceMappingURL=HelpLink.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-link-preview-option/lib/components/HelpLink.js
// module id = 5139
// module chunks = 2